import React, { useMemo } from 'react'
import { motion } from 'framer-motion'
import { match } from 'ts-pattern'

export default function KPICard({
  title,
  color,
  content,
  isLoading,
}: {
  title: string
  color: string
  content: React.ReactElement
  isLoading: boolean
}): JSX.Element {
  const backgroundColor = useMemo(() => {
    return match(color)
      .with('blue', () => 'from-denim to-primary-persian-blue')
      .with('green', () => 'from-apple-green to-forest-green')
      .with('orange', () => 'from-flame to-jasper')
      .otherwise(() => 'none')
  }, [color])

  if (isLoading) {
    return (
      <motion.div className="w-full p-4 h-[140px] rounded-lg text-transparent leading-[1.4em] rounded-[4px] bg-gradient-to-r from-silver via-white-smoke to-silver bg-[length:300%] animate-shimmer" />
    )
  }
  return (
    <div
      className={`w-full h-[140px] py-4 pl-4 font-Spartan rounded-lg flex flex-col justify-between bg-gradient-to-b text-white ${backgroundColor}`}>
      <span className={'font-bold text-md w-1/2'}>{title}</span>
      {content}
    </div>
  )
}
